const DATE_FORMAT = 'MM/dd/yyyy';

export default DATE_FORMAT;
